import React from 'react'
import { Layout } from '../components'

export default () => <Layout>TeamTelefoon video bellen</Layout>
